import { useAtomValue, useAtom } from "@effect-atom/atom-react";
import { Link } from "@tanstack/react-router";
import {
  selectedEngineAtom,
  isTransformingAtom,
  isSavingAtom,
  saveMessageAtom,
  transformAtom,
  saveFiddleAtom,
  currentFiddleAtom,
  autoTransformEnabledAtom,
  darkModeAtom,
  canSaveAtom,
} from "../atoms";
import { Engine, EngineNames } from "../lib/schemas";

const ENGINES: Engine[] = [
  "Saxon6",
  "Saxon9",
  "Saxon10",
  "Saxon11",
  "Saxon12",
  "Saxon12CS",
  "Xalan2",
  "libxslt",
  "Xee",
];

export function Header() {
  const [selectedEngine, setSelectedEngine] = useAtom(selectedEngineAtom);
  const isTransforming = useAtomValue(isTransformingAtom);
  const isSaving = useAtomValue(isSavingAtom);
  const saveMessage = useAtomValue(saveMessageAtom);
  const currentFiddle = useAtomValue(currentFiddleAtom);
  const [autoTransformEnabled, setAutoTransformEnabled] = useAtom(autoTransformEnabledAtom);
  const [darkMode, setDarkMode] = useAtom(darkModeAtom);
  const canSave = useAtomValue(canSaveAtom);
  const [, transform] = useAtom(transformAtom);
  const [, save] = useAtom(saveFiddleAtom);

  const handleTransform = () => {
    transform(undefined);
  };

  const handleSave = () => {
    save(undefined);
  };

  return (
    <div className="header">
      <h1>XSL Transform</h1>
      <div className="header-left">
        <Link to="/" className="btn btn-secondary">
          New
        </Link>
        <button
          className="btn btn-secondary"
          onClick={handleSave}
          disabled={isSaving || !canSave}
        >
          {isSaving ? (
            <>
              <span className="spinner"></span> Saving...
            </>
          ) : (
            "Save"
          )}
        </button>
        {saveMessage && <span className="save-message">{saveMessage}</span>}
      </div>
      <div className="controls">
        <select
          className="engine-select"
          value={selectedEngine}
          onChange={(e) => setSelectedEngine(e.target.value as Engine)}
        >
          {ENGINES.map((engine) => (
            <option key={engine} value={engine}>
              {EngineNames[engine]}
            </option>
          ))}
        </select>
        <button
          className="btn btn-primary"
          onClick={handleTransform}
          disabled={isTransforming}
        >
          {isTransforming ? (
            <>
              <span className="spinner"></span> Transforming...
            </>
          ) : (
            "Transform"
          )}
        </button>
        <label className="auto-transform-label">
          <input
            type="checkbox"
            checked={autoTransformEnabled}
            onChange={(e) => setAutoTransformEnabled(e.target.checked)}
          />
          Auto
        </label>
        <button
          className="btn btn-icon"
          onClick={() => setDarkMode(!darkMode)}
          title={darkMode ? "Light mode" : "Dark mode"}
        >
          {darkMode ? "☀️" : "🌙"}
        </button>
      </div>
    </div>
  );
}
